// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

availabilityStyles.availability = {
    container: {
        gap: 0,
        offsetCss: css`
            gap: 20px;
            justify-content: flex-start;
            align-items: center;
            &&& {
                width: 100%;
                margin: 0;
            }
            ${xScreen("lte","md")} {
                column-gap: 20px;
                row-gap: 12px;
            }
        `,
        css: css`
            margin-right: 20px;
        `,
    },
    // Override Grid Item width instead of change GridItem into StyledWrapper
    messageGridItem: {
        css: css`
            width: auto;
            flex-basis: auto;
            ${xScreen("lte","md")} {
                padding: 0;
            }
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        css: css`
            width: auto;
            flex-basis: auto;
            ${xScreen("lte","md")} {
                padding: 0;
            }
        `,
    },
    errorWrapper: {
        css: css`
            margin-right: 20px;
        `,
    },
    inventoryMessage: {
        css: css`
            align-items: center;
        `,
    },
};